import { Table, Badge } from "antd";
import Layout, { Content, Header } from "antd/es/layout/layout";
import React, { useState } from "react";
// import test from "../../service/test.json"
import CustomVisitsFilter from "../customFilter/CustomVisitsFilter";
import { useQuery } from "@tanstack/react-query";
import { getStaticExpertFields } from "../../service/api";
import Swal from "sweetalert2";

function MyReviews() {
  const [loading , setLoading] = useState()
  const staticExpertFieldsQuery = useQuery(
    ["staticsExpertFields"],
    getStaticExpertFields
  );
  const visitStates = staticExpertFieldsQuery?.data?.VISITS_STATES;

  const [visitData, setVisitData] = useState();

  const columns = [
    {
      title: "نام کشاورز",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "نوع کشت",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "مساحت",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "تاریخ انجام بازدید",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "منطقه",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "وضعیت",
      dataIndex: "state",
      key: "state",
      render: (data) => {
        if (
          (data?.currentState === "VISIT_SUPPORT") &
          (data?.subState === "VISIT_SENT") &
          (data?.status === "COMPLETED")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#207E4F"
              text="تایید شده"
            />
          );
        } else if (
          (data?.currentState === "VISIT_REPORT_WRITING") &
            (data?.subState === null) &
            (data?.status === "PROCESSING") ||
          (data?.currentState === "EDUCATION_MANAGEMENT") &
            (data?.subState === null) &
            (data?.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_COMPLETED") &
            (data?.status === "PROCESSING")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#00A9BF"
              text="در حال تکمیل گزارش"
            />
          );
        } else if (
          ((data?.currentState === "VISIT_DATA_PROCESS") &
          (data?.subState === null) &
          (data?.status === "PROCESSING") )||   ((data?.currentState === "VISIT_SUPPORT") &
          (data?.subState === "VISIT_FINANCIAL_PROCESSING") &
          (data?.status === "DONE") )
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#E8EC18"
              text="پردازش بازدید"
            />
          );
        } else if (
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_FULFILMENT") &
            (data.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_DONE") &
            (data.status === "DONE")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#9D9D9D"
              text="انجام بازدید"
            />
          );
        } else {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#f10808"
              text="نامشخص"
            />
          );
        }
      },
    },
    {
      title: "عملیات",
      dataIndex: "operation",
      key: "operation",

      render: (data) => {
        if (
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_FULFILMENT") &
            (data.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_DONE") &
            (data.status === "DONE")
        ) {
          return (
            <button
              style={{
                border: " 1px solid #EEE",
                borderRadius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 25px",
              }}
              onClick={() =>
                Swal.fire({
                  confirmButtonText: "متوجه شدم",
                  icon: "info",
                  html: "کارشناس گرامی انجام این بازدید به شما محول شده است لطفا جهت انجام بازدید به اپلیکیشن اگرویار مراجعه نمائید",
                })
              }
            >
              {"شروع بازدید"}
            </button>
          );
        } else if (
          (data?.currentState === "VISIT_SUPPORT") &
          (data?.subState === "VISIT_SENT") &
          (data?.status === "COMPLETED")
        ) {
          return (
            <a
              style={{
                border: " 1px solid #EEE",
                whiteSpace: "nowrap",
                borderRadius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 20px",
              }}
              href={data?.reportFile}
              target="_blank" rel="noreferrer"
            >
              {"مشاهده گزارش"}
            </a>
          );
        } else {
          return (
            <p
              style={{
                border: " 1px solid #EEE",
                borderRdivdius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 6px",
                borderRadius: "20px",
                whiteSpace: "nowrap",
                width: "100%",
                margin: "auto",
                opacity: "50%",
              }}
            >
              مشاهده گزارش
            </p>
          );
        }
      },
    },
  ];

  return (
    <Layout className="p-3">
      <Content className="bg-white  shadow-lg rounded-lg p-3 ">
        <Header className="text-[#00A9BF] bg-[#FFF] text-[2.3rem] max-lg:text-[1.5rem] mx-[1rem] font-body mt-3 rounded-md mb-5 max-lg:whitespace-nowrap max-lg:m-auto">
          <span>بازدیدهای من</span>
        </Header>
        <p className="text-[#00A9BF] font-body text-base mb-2">لیست تمام بازدیدهایی که شما به عنوان کارشناس از طریق اپلیکیشن اگرویار انجام داده اید</p>
        <div className="pb-3">
          <CustomVisitsFilter
            states={visitStates}
            setVisitData={setVisitData}
            setLoading={setLoading}
          />
        </div>
        <Table
        loading={loading ? true : false}
          scroll={{
            x: 950,
          }}
          showHeader={true}
          pagination={false}
          style={{
            fontFamily: "body",
          }}
          dataSource={visitData}
          columns={columns}
        ></Table>
      </Content>
    </Layout>
  );
}

export default MyReviews;
